var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgColleagueIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0582 11.6928C17.2751 9.97471 18.1477 7.05168 17.2309 4.41469C16.3141 1.77769 13.81 0.0078125 10.9958 0.0078125C8.18163 0.0078125 5.6775 1.77769 4.76072 4.41469C3.84394 7.05168 4.71652 9.97471 6.93338 11.6928C2.7532 13.3413 0.0071625 17.3465 0 21.8054V22.8947C0 23.4964 0.492102 23.9841 1.09914 23.9841H20.8837C21.4907 23.9841 21.9828 23.4964 21.9828 22.8947V21.8054C21.9771 17.3486 19.235 13.3441 15.0582 11.6928ZM6.59485 6.55431C6.59485 4.14775 8.56326 2.19686 10.9914 2.19686C13.4196 2.19686 15.388 4.14775 15.388 6.55431C15.388 8.96086 13.4196 10.9118 10.9914 10.9118C8.56326 10.9118 6.59485 8.96086 6.59485 6.55431ZM10.9914 13.0905C6.1351 13.0905 2.19828 16.9923 2.19828 21.8054H19.7845C19.7845 16.9923 15.8477 13.0905 10.9914 13.0905Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgColleagueIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/colleagueIcon.57cb989a56705db1d6ecc5b9f4f26083.svg";